"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3564],{

/***/ 12172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RadioFieldInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6686);




/**
 * Primary UI component for radio inputs.
 */ const RadioFieldInput = (param)=>{
    let { label , value ="" , onChange , className , hint , validations , required , options , testid , itemClassName =""  } = param;
    const errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_3__/* .validate */ .G)(value, validations);
    const inputName = label === null || label === void 0 ? void 0 : label.toString().toLowerCase().trim().replaceAll(" ", "_");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
        className: [
            "flex flex-col gap-3",
            className
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("legend", {
                className: "text-sm font-medium text-[#153e3e] transition-all ".concat(errorMessage ? "text-red-500" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: required ? "after:content-['*'] after:ml-1 after:text-red-500" : "",
                        children: label
                    }),
                    hint ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "ml-2 text-xs font-normal",
                        children: hint
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex flex-col gap-3 sm:flex-row sm:flex-wrap",
                children: options === null || options === void 0 ? void 0 : options.map((option, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        className: "".concat(itemClassName, " flex cursor-pointer items-center gap-2 text-sm font-medium text-[#153e3e]"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                "data-testid": testid ? "".concat(testid, "-").concat(i) : null,
                                type: "radio",
                                className: "peer sr-only",
                                name: inputName,
                                value: option,
                                checked: value === option,
                                onChange: (e)=>{
                                    onChange && onChange(e.target.value, false);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                "aria-hidden": "true",
                                className: "h-[18px] w-[18px] shrink-0 rounded-full border-2 border-[#153e3e] bg-transparent transition-all peer-checked:border-[5px] peer-focus-visible:ring-2 peer-focus-visible:ring-[#153e3e]/30"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "min-w-0",
                                children: option
                            })
                        ]
                    }, option))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            })
        ]
    });
};


/***/ }),

/***/ 11734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ libs_useFileUploader; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/media/uploadMedia.ts

const UPLOAD_MEDIA = (0,_generated/* graphql */.B)("\n  mutation UploadMedia($input: MediaUploadInput!) {\n    uploadMedia(input: $input) {\n      preSignedUrl\n      uploadedFileUrl\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
;// CONCATENATED MODULE: ./libs/useFileUploader.ts



const useFileUploader = ()=>{
    const [uploadMedia] = (0,useMutation/* useMutation */.D)(UPLOAD_MEDIA);
    const generateSafeFileName = (name)=>{
        return (0,v4/* default */.Z)();
    };
    const uploadFile = async (file)=>{
        var ref, ref1;
        const response = await uploadMedia({
            variables: {
                input: {
                    contentType: "application/x-www-form-urlencoded",
                    filename: generateSafeFileName(file.name)
                }
            }
        });
        const preSignedUrl = (ref = response.data) === null || ref === void 0 ? void 0 : ref.uploadMedia.preSignedUrl;
        const uploadedFileUrl = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.uploadMedia.uploadedFileUrl;
        await fetch(preSignedUrl, {
            method: "PUT",
            body: file,
            headers: {
                "Content-Type": file.type
            }
        });
        return uploadedFileUrl !== null && uploadedFileUrl !== void 0 ? uploadedFileUrl : "";
    };
    return uploadFile;
};
/* harmony default export */ var libs_useFileUploader = (useFileUploader);


/***/ }),

/***/ 63564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ details; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/inputs/DateTimeInput.tsx
var DateTimeInput = __webpack_require__(8194);
// EXTERNAL MODULE: ./components/inputs/DropdownInput.tsx
var DropdownInput = __webpack_require__(61993);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/ui-react/dist/esm/primitives/Autocomplete/Autocomplete.mjs + 112 modules
var Autocomplete = __webpack_require__(49226);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
// EXTERNAL MODULE: ./components/inputs/Validations.tsx
var Validations = __webpack_require__(6686);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 2 modules
var util = __webpack_require__(52229);
;// CONCATENATED MODULE: ./components/inputs/SearchInput.tsx







const SearchInput = (param)=>{
    let { label , placeholder , value ="" , onChange , className , hint , validations , required , border ="border" , onKeyDown , max , min , options , addValueInOptions =false , textColour , labelBgColour , variation ="v1"  } = param;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    var ref;
    const backgroundColour = (ref = labelBgColour !== null && labelBgColour !== void 0 ? labelBgColour : theme === null || theme === void 0 ? void 0 : theme.backgroundColour) !== null && ref !== void 0 ? ref : "#0D0E11";
    const [autocompleteValue, setAutocompleteValue] = (0,react.useState)(value);
    (0,react.useEffect)(()=>{
        setAutocompleteValue(value);
    }, [
        value
    ]);
    const errorMessage = (0,Validations/* validate */.G)(value, validations);
    const generateStyles = (0,react.useMemo)(()=>{
        let base = "transition-all outline-none ";
        const errorStyles = errorMessage ? "text-red-500 border-red-500" : "";
        let textStyles = "text-sm placeholder-gray-500";
        let positionStyles = "";
        if (variation === "v1") {
            base = "bg-transparent rounded-2xl";
        }
        if (variation === "v2") {
            base = "!bg-[#F7E5E4] rounded-none !border-none";
            textStyles = "text-sm text-black black-autocomplete-text font-semibold";
            border = "border-none";
        }
        const payload = "".concat(base, " ").concat(textStyles, " ").concat(positionStyles, " ").concat(border, " ").concat(errorStyles);
        console.log({
            payload
        });
        return payload;
    }, [
        border,
        errorMessage,
        variation
    ]);
    const getOptions = ()=>{
        if (!(0,util/* isBasicOptions */.P)(options)) options = options.map((o)=>{
            return {
                id: o === null || o === void 0 ? void 0 : o.value.toString(),
                label: o === null || o === void 0 ? void 0 : o.label
            };
        });
        const isValueInOptions = options.some((option)=>option.label === autocompleteValue);
        const modifiedOptions = addValueInOptions && !isValueInOptions ? [
            {
                id: value,
                label: value
            },
            ...options
        ] : options;
        return modifiedOptions;
    };
    const input = /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* Autocomplete */.F, {
        label: label,
        clearButtonLabel: label ? "Clear " + label : "Clear search",
        onClear: ()=>setAutocompleteValue(""),
        required: required,
        onKeyDown: onKeyDown,
        value: autocompleteValue,
        onChange: (e)=>{
            setAutocompleteValue(e.target.value);
            const isInvalid = (0,Validations/* validate */.G)(e.target.value, validations) !== "";
            onChange && onChange(e.target.value, isInvalid);
        },
        onSelect: (e)=>{
            setAutocompleteValue(e.label);
            const isInvalid = (0,Validations/* validate */.G)(e.id, validations) !== "";
            onChange && onChange(e.id, isInvalid);
        },
        max: max,
        min: min,
        placeholder: placeholder,
        hasSearchIcon: false,
        className: generateStyles,
        color: variation === "v1" ? "grey" : "black",
        inputStyles: {
            padding: "15.5px 16px",
            fontSize: "14px",
            color: "black",
            ...variation === "v2" ? {
                border: "none",
                color: "#000000"
            } : {},
            ...variation === "v1" ? {
                borderRadius: "1rem"
            } : {}
        },
        options: getOptions(),
        crossOrigin: undefined,
        onPointerEnterCapture: undefined,
        onPointerOutCapture: undefined,
        onPointerLeaveCapture: undefined
    });
    const showLabel = (0,react.useMemo)(()=>label && variation === "v1", [
        label,
        variation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        className: [
            "flex flex-col my-4",
            className
        ].join(" "),
        style: {
            color: textColour
        },
        children: [
            showLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute text-sm mb-2 ml-2 z-10 ".concat(backgroundColour, " ").concat(required ? "pl-2" : "px-2", " transition-all ").concat(errorMessage ? "text-red-500" : ""),
                style: {
                    background: backgroundColour,
                    transform: "translateY(-50%)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        backgroundColor: backgroundColour
                    },
                    className: "z-10 ".concat(required ? "after:content-['*'] after:mx-2 after:text-red-500" : ""),
                    children: label
                })
            }),
            input,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/inputs/TextAreaInput.tsx
var TextAreaInput = __webpack_require__(33923);
// EXTERNAL MODULE: ./components/inputs/TextInput.tsx
var TextInput = __webpack_require__(39618);
;// CONCATENATED MODULE: ./components/event/GoogleLocationField.tsx




const PLACES_API_KEY = "AIzaSyAIIxiLEyU5hbDlj5Wu3aKsw2GNqh22Xmk";
const buildMapsUrl = (formattedAddress, placeId)=>"https://www.google.com/maps/search/?api=1&query=".concat(encodeURIComponent(formattedAddress), "&query_place_id=").concat(encodeURIComponent(placeId));
function useDebouncedCallback(fn, delayMs) {
    const timeoutRef = (0,react.useRef)(null);
    const fnRef = (0,react.useRef)(fn);
    fnRef.current = fn;
    return (0,react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>fnRef.current(...args), delayMs);
    }, [
        delayMs
    ]);
}
const generateSessionToken = ()=>"".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2));
function PlacesAutocompleteInput(param) {
    let { label ="Location" , placeholder ="123 Main street, London, WC2N 5DU" , value , required , className , mapUrl , onChangeText , onSelect  } = param;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const [query, setQuery] = (0,react.useState)(value !== null && value !== void 0 ? value : "");
    const [suggestions, setSuggestions] = (0,react.useState)([]);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [highlightedIndex, setHighlightedIndex] = (0,react.useState)(-1);
    const [error, setError] = (0,react.useState)(null);
    const [hasSelectedPlace, setHasSelectedPlace] = (0,react.useState)(Boolean(value && mapUrl));
    const [showSelectionError, setShowSelectionError] = (0,react.useState)(false);
    const [currentMapUrl, setCurrentMapUrl] = (0,react.useState)(mapUrl);
    const sessionTokenRef = (0,react.useRef)(generateSessionToken());
    const containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        setQuery(value !== null && value !== void 0 ? value : "");
    }, []);
    (0,react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const runSearch = (0,react.useCallback)(async (input)=>{
        if (!PLACES_API_KEY) {
            setError("Missing Google Places API key");
            setIsLoading(false);
            return;
        }
        if (!input || input.trim().length < 3) {
            setSuggestions([]);
            setIsOpen(false);
            setIsLoading(false);
            return;
        }
        try {
            const response = await fetch("https://places.googleapis.com/v1/places:autocomplete", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Goog-Api-Key": PLACES_API_KEY
                },
                body: JSON.stringify({
                    input,
                    sessionToken: sessionTokenRef.current
                })
            });
            if (!response.ok) {
                var ref;
                const body = await response.json().catch(()=>null);
                throw new Error((body === null || body === void 0 ? void 0 : (ref = body.error) === null || ref === void 0 ? void 0 : ref.message) || "Request failed (".concat(response.status, ")"));
            }
            const data = await response.json();
            var ref1, ref2;
            const predictions = ((ref1 = data === null || data === void 0 ? void 0 : data.suggestions) !== null && ref1 !== void 0 ? ref1 : []).filter((s)=>!!s.placePrediction).map((s)=>{
                var ref, ref1, ref3, ref4, ref5;
                return {
                    placeId: s.placePrediction.placeId,
                    text: (ref2 = (ref = s.placePrediction.text) === null || ref === void 0 ? void 0 : ref.text) !== null && ref2 !== void 0 ? ref2 : "",
                    mainText: (ref1 = s.placePrediction.structuredFormat) === null || ref1 === void 0 ? void 0 : (ref3 = ref1.mainText) === null || ref3 === void 0 ? void 0 : ref3.text,
                    secondaryText: (ref4 = s.placePrediction.structuredFormat) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.secondaryText) === null || ref5 === void 0 ? void 0 : ref5.text
                };
            });
            setSuggestions(predictions);
            setIsOpen(predictions.length > 0);
            setHighlightedIndex(-1);
            setError(null);
        } catch (err) {
            console.error("Places autocomplete error:", err);
            setSuggestions([]);
            var ref3;
            setError((ref3 = err === null || err === void 0 ? void 0 : err.message) !== null && ref3 !== void 0 ? ref3 : "Something went wrong");
        } finally{
            setIsLoading(false);
        }
    }, []);
    const debouncedSearch = useDebouncedCallback(runSearch, 300);
    const handleChange = (data)=>{
        setQuery(data);
        onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText(data);
        setHasSelectedPlace(false);
        setShowSelectionError(false);
        setCurrentMapUrl(undefined);
        setIsLoading(true);
        debouncedSearch(data);
    };
    const fetchPlaceDetails = async (prediction)=>{
        try {
            var ref, ref1;
            const response = await fetch("https://places.googleapis.com/v1/places/".concat(prediction.placeId), {
                headers: {
                    "X-Goog-Api-Key": PLACES_API_KEY,
                    "X-Goog-FieldMask": "id,formattedAddress,location"
                }
            });
            const data = await response.json();
            var ref2;
            return {
                formattedAddress: (ref2 = data === null || data === void 0 ? void 0 : data.formattedAddress) !== null && ref2 !== void 0 ? ref2 : prediction.text,
                lat: data === null || data === void 0 ? void 0 : (ref = data.location) === null || ref === void 0 ? void 0 : ref.latitude,
                lng: data === null || data === void 0 ? void 0 : (ref1 = data.location) === null || ref1 === void 0 ? void 0 : ref1.longitude,
                mapUrl: buildMapsUrl(prediction.text, prediction.placeId)
            };
        } catch (err) {
            console.error("Place details error:", err);
            return {
                formattedAddress: prediction.text,
                mapUrl: buildMapsUrl(prediction.text, prediction.placeId)
            };
        }
    };
    const handleSelect = async (prediction)=>{
        setQuery(prediction.text);
        setHasSelectedPlace(true);
        setShowSelectionError(false);
        setIsOpen(false);
        setSuggestions([]);
        const details = await fetchPlaceDetails(prediction);
        const selectedPlace = {
            ...details,
            formattedAddress: prediction.text
        };
        setQuery(prediction.text);
        setCurrentMapUrl(details.mapUrl);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedPlace);
        sessionTokenRef.current = generateSessionToken();
    };
    const handleKeyDown = (e)=>{
        if (!isOpen || suggestions.length === 0) return;
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlightedIndex((i)=>(i + 1) % suggestions.length);
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlightedIndex((i)=>i <= 0 ? suggestions.length - 1 : i - 1);
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (highlightedIndex >= 0) handleSelect(suggestions[highlightedIndex]);
        } else if (e.key === "Escape") {
            setIsOpen(false);
        }
    };
    var ref, ref1, ref2, _mainText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        innerRef: containerRef,
        className: "relative w-full flex flex-col my-3 ".concat(className !== null && className !== void 0 ? className : ""),
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "absolute z-10 text-sm -translate-y-1/2 -translate-x-1 mb-2 ml-2 ".concat(required ? "pl-2" : "px-2"),
                style: {
                    backgroundColor: theme === null || theme === void 0 ? void 0 : theme.backgroundColour
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "",
                        style: {
                            color: theme === null || theme === void 0 ? void 0 : theme.textColour
                        },
                        children: label
                    }),
                    required && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            color: "#dc2626"
                        },
                        children: " *"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                value: query,
                placeholder: placeholder,
                onChange: (e)=>handleChange(e.target.value),
                onFocus: ()=>suggestions.length > 0 && setIsOpen(true),
                onBlur: ()=>{
                    setShowSelectionError(Boolean(query.trim()) && !hasSelectedPlace);
                },
                onKeyDown: handleKeyDown,
                autoComplete: "off",
                className: "w-full box-border px-4 py-4 text-sm border rounded-2xl outline-none bg-transparent",
                style: {
                    borderColor: "#9ca0af",
                    backgroundColor: theme === null || theme === void 0 ? void 0 : theme.backgroundColour,
                    color: theme === null || theme === void 0 ? void 0 : theme.textColour
                }
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "text-xs mt-1",
                style: {
                    color: "#dc2626"
                },
                children: error
            }),
            showSelectionError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "text-xs mt-1",
                style: {
                    color: "#dc2626"
                },
                children: "Please select an item form the dropdown"
            }),
            currentMapUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "mt-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: currentMapUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "text-xs underline",
                    children: "View on Google Maps ↗"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                show: isOpen,
                className: "absolute z-50 top-full left-0 right-0 mt-1 rounded shadow-lg border overflow-hidden max-h-64 overflow-y-auto",
                style: {
                    borderColor: (ref = theme === null || theme === void 0 ? void 0 : theme.borderColour) !== null && ref !== void 0 ? ref : "#d1d5db",
                    backgroundColor: (ref1 = theme === null || theme === void 0 ? void 0 : theme.backgroundColourSecondary) !== null && ref1 !== void 0 ? ref1 : theme === null || theme === void 0 ? void 0 : theme.backgroundColour
                },
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "px-4 py-2 text-sm opacity-60",
                        children: "Searching…"
                    }),
                    !isLoading && suggestions.map((s, i)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box["default"], {
                            onMouseDown: (e)=>{
                                e.preventDefault();
                                handleSelect(s);
                            },
                            onMouseEnter: ()=>setHighlightedIndex(i),
                            className: "px-4 py-2 cursor-pointer text-sm",
                            style: {
                                ...i === highlightedIndex ? {
                                    backgroundColor: "rgba(0,0,0,0.05)"
                                } : undefined,
                                ...i < suggestions.length - 1 ? {
                                    borderBottom: "1px solid ".concat((ref2 = theme === null || theme === void 0 ? void 0 : theme.borderColour) !== null && ref2 !== void 0 ? ref2 : "#e5e7eb")
                                } : undefined
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "font-medium",
                                    textColour: "textColour",
                                    children: (_mainText = s.mainText) !== null && _mainText !== void 0 ? _mainText : s.text
                                }),
                                s.secondaryText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "text-xs opacity-60",
                                    children: s.secondaryText
                                })
                            ]
                        }, s.placeId);
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
// EXTERNAL MODULE: ./layouts/CreateEventLayout.tsx + 6 modules
var CreateEventLayout = __webpack_require__(67526);
// EXTERNAL MODULE: ./libs/CreateEvent/useEventEditor.tsx + 6 modules
var useEventEditor = __webpack_require__(25687);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./components/inputs/FileInput.tsx + 5 modules
var FileInput = __webpack_require__(40296);
// EXTERNAL MODULE: ./libs/useFileUploader.ts + 1 modules
var useFileUploader = __webpack_require__(11734);
// EXTERNAL MODULE: ./libs/Utility/validation.ts
var validation = __webpack_require__(49532);
// EXTERNAL MODULE: ./components/inputs/RichTextEditor/RichTextEditor.tsx
var RichTextEditor = __webpack_require__(19460);
// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
// EXTERNAL MODULE: ./libs/useOrganisationProfile.ts
var useOrganisationProfile = __webpack_require__(19058);
// EXTERNAL MODULE: ./components/inputs/RadioFieldInput.tsx
var RadioFieldInput = __webpack_require__(12172);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./libs/EventTime/index.ts + 26 modules
var EventTime = __webpack_require__(26647);
;// CONCATENATED MODULE: ./libs/CreateEvent/eventDateTime.ts

const SCHEDULE_FIELDS = [
    "startDateTime",
    "entryDateTime",
    "endDateTime",
    "registrationCloseDateTime"
];
const SCHEDULE_FIELD_LABELS = {
    startDateTime: "Event start",
    entryDateTime: "Entry time",
    endDateTime: "Event end",
    registrationCloseDateTime: "Registration close"
};
/**
 * Optimistically mirrors the backend's timezone-only update semantics: each
 * schedule value keeps its wall-clock components while its UTC instant moves.
 */ const setEventTimeZoneId = (event, timeZoneId)=>{
    const current = event !== null && event !== void 0 ? event : {};
    const previousTimeZoneId = (0,EventTime/* getEventTimeZone */.$1)(current);
    if (!previousTimeZoneId || previousTimeZoneId === timeZoneId) {
        return {
            ...current,
            timeZoneId
        };
    }
    const shiftedSchedule = {};
    for (const field of SCHEDULE_FIELDS){
        const value = current[field];
        if (!value) continue;
        const conversion = (0,EventTime/* reinterpretTimestamp */.bC)(value, previousTimeZoneId, timeZoneId);
        if (conversion.status !== "valid") {
            if (field === "entryDateTime") {
                var _startDateTime, ref;
                shiftedSchedule[field] = (ref = (_startDateTime = shiftedSchedule.startDateTime) !== null && _startDateTime !== void 0 ? _startDateTime : current.startDateTime) !== null && ref !== void 0 ? ref : null;
                continue;
            }
            throw new Error("".concat(SCHEDULE_FIELD_LABELS[field], ": ").concat(conversion.message));
        }
        shiftedSchedule[field] = conversion.value;
    }
    return {
        ...current,
        ...shiftedSchedule,
        timeZoneId
    };
};

;// CONCATENATED MODULE: ./pages/create-event/details.tsx

























const DetailsForm = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const uploadFile = (0,useFileUploader/* default */.Z)();
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    var ref10;
    const { profile: organisationProfile  } = (0,useOrganisationProfile/* useOrganisationProfile */.k)((ref10 = profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref10 !== void 0 ? ref10 : profile === null || profile === void 0 ? void 0 : profile.university);
    const { formData , setFormData , validationRules , errors , setErrors  } = (0,useEventEditor/* useEventEditor */.O)();
    var ref11, ref12;
    const initialTimeZoneId = (ref12 = (ref11 = formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.timeZoneId) !== null && ref11 !== void 0 ? ref11 : (0,EventTime/* resolveLegacyTimeZoneId */.N9)(formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.timeZone)) !== null && ref12 !== void 0 ? ref12 : (formData === null || formData === void 0 ? void 0 : (ref2 = formData.event) === null || ref2 === void 0 ? void 0 : ref2.timeZone) ? undefined : (0,EventTime/* getBrowserTimeZoneId */.ot)();
    var ref13;
    const [eventDetailsData, setEventDetailsData] = (0,react.useState)({
        ...formData === null || formData === void 0 ? void 0 : formData.event,
        timeZoneId: initialTimeZoneId,
        fundraising: (ref13 = formData === null || formData === void 0 ? void 0 : formData.fundraising) !== null && ref13 !== void 0 ? ref13 : {}
    });
    const [timeZoneError, setTimeZoneError] = (0,react.useState)();
    var ref14;
    const eventTimeZone = (ref14 = (0,EventTime/* getEventTimeZone */.$1)(eventDetailsData)) !== null && ref14 !== void 0 ? ref14 : (0,EventTime/* getBrowserTimeZoneId */.ot)();
    const hasUnresolvedLegacyTimeZone = !!(eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.timeZone) && !eventDetailsData.timeZoneId && !(0,EventTime/* resolveLegacyTimeZoneId */.N9)(eventDetailsData.timeZone);
    const timeZoneOptions = (0,react.useMemo)(()=>{
        return (0,EventTime/* getTimeZoneOptions */.hA)(eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.startDateTime);
    }, [
        eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.startDateTime
    ]);
    const selectedTimeZoneOption = (0,react.useMemo)(()=>{
        return timeZoneOptions.find((param)=>{
            let { value  } = param;
            return value === (eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.timeZoneId);
        });
    }, [
        eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.timeZoneId,
        timeZoneOptions
    ]);
    var ref15;
    const internalLocationsOptions = ((ref15 = organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.locations) !== null && ref15 !== void 0 ? ref15 : []).map((loc)=>({
            label: loc,
            value: loc
        }));
    const initialMapLocationText = (0,react.useMemo)(()=>{
        if (eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventLocationMapLink) {
            return eventDetailsData.eventLocationMapLink;
        }
        const url = eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventLocationMapUrl;
        if (!url) return "";
        try {
            const query = new URL(url).searchParams.get("query");
            return query ? decodeURIComponent(query) : "";
        } catch (err) {
            return "";
        }
    }, []);
    (0,react.useEffect)(()=>{
        const persisted = formData === null || formData === void 0 ? void 0 : formData.event;
        if (!persisted) return;
        var _timeZoneId, ref, ref1;
        const schedule = {
            timeZoneId: (ref1 = (ref = (_timeZoneId = persisted.timeZoneId) !== null && _timeZoneId !== void 0 ? _timeZoneId : (0,EventTime/* resolveLegacyTimeZoneId */.N9)(persisted.timeZone)) !== null && ref !== void 0 ? ref : eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.timeZoneId) !== null && ref1 !== void 0 ? ref1 : persisted.timeZone ? undefined : (0,EventTime/* getBrowserTimeZoneId */.ot)(),
            startDateTime: persisted.startDateTime,
            entryDateTime: persisted.entryDateTime,
            endDateTime: persisted.endDateTime,
            registrationCloseDateTime: persisted.registrationCloseDateTime
        };
        setEventDetailsData((current)=>{
            if (current && Object.entries(schedule).every((param)=>{
                let [key, value] = param;
                return current[key] === value;
            })) {
                return current;
            }
            return {
                ...current,
                ...schedule
            };
        });
    }, [
        formData === null || formData === void 0 ? void 0 : (ref3 = formData.event) === null || ref3 === void 0 ? void 0 : ref3.timeZoneId,
        formData === null || formData === void 0 ? void 0 : (ref4 = formData.event) === null || ref4 === void 0 ? void 0 : ref4.timeZone,
        formData === null || formData === void 0 ? void 0 : (ref5 = formData.event) === null || ref5 === void 0 ? void 0 : ref5.startDateTime,
        formData === null || formData === void 0 ? void 0 : (ref6 = formData.event) === null || ref6 === void 0 ? void 0 : ref6.entryDateTime,
        formData === null || formData === void 0 ? void 0 : (ref7 = formData.event) === null || ref7 === void 0 ? void 0 : ref7.endDateTime,
        formData === null || formData === void 0 ? void 0 : (ref8 = formData.event) === null || ref8 === void 0 ? void 0 : ref8.registrationCloseDateTime
    ]);
    (0,react.useEffect)(()=>{
        if (!!eventDetailsData) {
            var ref;
            delete eventDetailsData.eventType;
            const { fundraising , ...eventData } = eventDetailsData;
            const payload = {
                ...formData,
                event: {
                    ...formData === null || formData === void 0 ? void 0 : formData.event,
                    ...eventData
                },
                ...fundraising ? {
                    fundraising: {
                        ...formData === null || formData === void 0 ? void 0 : formData.fundraising,
                        ...fundraising
                    }
                } : {}
            };
            //@ts-ignore
            if ((payload === null || payload === void 0 ? void 0 : payload.title) || (payload === null || payload === void 0 ? void 0 : (ref = payload.event) === null || ref === void 0 ? void 0 : ref.title)) {
                debouncedSave({
                    formData: payload,
                    errors
                });
            }
        }
    }, [
        eventDetailsData
    ]);
    const debouncedSave = (0,react.useCallback)((0,util/* debounce */.Ds)((input)=>{
        var ref;
        const hasErrors = !!(input === null || input === void 0 ? void 0 : input.errors) && (0,lodash.isArray)(input === null || input === void 0 ? void 0 : input.errors) && (input === null || input === void 0 ? void 0 : (ref = input.errors) === null || ref === void 0 ? void 0 : ref.length) > 0;
        if (!hasErrors && !!(input === null || input === void 0 ? void 0 : input.formData)) saveDetails({
            ...input.formData
        });
    }, 1000), []);
    const saveDetails = async (payload)=>{
        setFormData(payload);
    };
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const hasError = !!message || message !== "";
            const isCleared = payload.find((f)=>f.eleId === testId) && !hasError;
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate && hasError) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    var ref16, ref17, ref18, ref19, ref20, ref21;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
        className: "flex w-full space-x-12",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex flex-col w-full -mb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                            tooltip: "Event title is required to publish",
                            labelBgColour: theme.backgroundColourSecondary,
                            testid: "name-input",
                            validations: {
                                maxLength: {
                                    value: 150,
                                    message: "Title must be 150 characters or less"
                                }
                            },
                            required: (0,validation/* isFieldRequired */.zx)(validationRules.find((f)=>{
                                return f[0].includes((eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? "fundraising_title" : "event_title");
                            })),
                            hint: "(Maximum of 150 characters)",
                            label: "Title",
                            placeholder: (eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? "Fundraiser Name" : "Event Name",
                            className: "flex-1 mr-2",
                            value: (eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? eventDetailsData === null || eventDetailsData === void 0 ? void 0 : (ref9 = eventDetailsData.fundraising) === null || ref9 === void 0 ? void 0 : ref9.title : eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.title,
                            onChange: (data)=>{
                                setEventDetailsData((state)=>{
                                    return {
                                        ...state,
                                        ...(state === null || state === void 0 ? void 0 : state.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? {
                                            title: data,
                                            fundraising: {
                                                ...state === null || state === void 0 ? void 0 : state.fundraising,
                                                title: data
                                            }
                                        } : {
                                            title: data
                                        }
                                    };
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                            tooltip: "A short event description is required to publish",
                            labelBgColour: theme.backgroundColourSecondary,
                            testid: "short-description-input",
                            validations: {
                                maxLength: {
                                    value: 300,
                                    message: "Description must be 300 characters or less"
                                }
                            },
                            required: (0,validation/* isFieldRequired */.zx)(validationRules.find((f)=>f[0].includes("event_shortDescription"))),
                            setError: errorHandler("event"),
                            hint: "(Maximum of 300 characters)",
                            label: "Short Description",
                            placeholder: "Write a short description of your ".concat((eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? "fundraiser" : "event"),
                            className: "flex-1 ml-2 sm:ml-0 mt-1",
                            value: eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.shortDescription,
                            onChange: (data)=>{
                                setEventDetailsData({
                                    ...eventDetailsData !== null && eventDetailsData !== void 0 ? eventDetailsData : {},
                                    shortDescription: data
                                });
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextEditor/* default */.Z, {
                    tooltip: "A full event description is required to publish",
                    testid: "description-input",
                    validations: {
                    },
                    className: "mt-2",
                    required: (0,validation/* isFieldRequired */.zx)(validationRules.find((f)=>{
                        return f[0].includes((eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? "fundraising_description" : "event_description");
                    })),
                    setError: errorHandler("event"),
                    // hint="(Maximum of 3000 characters)"
                    label: "Description",
                    placeholder: "Write all of the details of your ".concat((eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? "fundraiser" : "event", "..."),
                    value: eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.description,
                    onChange: (jsonString)=>{
                        if ((eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.description) !== jsonString) setEventDetailsData((state)=>{
                            const payload = {
                                ...state,
                                ...(state === null || state === void 0 ? void 0 : state.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? {
                                    description: jsonString,
                                    fundraising: {
                                        ...state === null || state === void 0 ? void 0 : state.fundraising,
                                        description: jsonString
                                    }
                                } : {
                                    description: jsonString
                                }
                            };
                            return payload;
                        });
                    }
                }),
                internalLocationsOptions && internalLocationsOptions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "mb-16 -mt-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioFieldInput/* RadioFieldInput */.g, {
                            testid: "internal-or-exteral-input",
                            hint: "Select this option if the event is taking place within the university",
                            options: [
                                "Yes",
                                "No"
                            ],
                            label: "Is this an internal location?",
                            className: "text-xl ml-[1px]",
                            value: (eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.isInternal) ? "Yes" : "No",
                            onChange: (data)=>{
                                setEventDetailsData((state)=>({
                                        ...state,
                                        isInternal: data === "Yes"
                                    }));
                            }
                        }),
                        (eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.isInternal) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "mt-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownInput/* DropdownInput */.f, {
                                value: eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.internalLocation,
                                label: "Location",
                                options: internalLocationsOptions,
                                onChange: (data)=>{
                                    setEventDetailsData((state)=>({
                                            ...state,
                                            internalLocation: data
                                        }));
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAreaInput/* TextAreaInput */.F, {
                    tooltip: "An event location is required to publish",
                    show: (0,validation/* shouldShowField */.f5)(validationRules.find((f)=>f[0].includes("event_eventLocation"))),
                    testid: "location-input",
                    label: "Name of venue",
                    placeholder: "Add your venue name here",
                    required: (0,validation/* isFieldRequired */.zx)(validationRules.find((f)=>f[0].includes("event_eventLocation"))),
                    setError: errorHandler("event"),
                    className: "-mt-6 [&>textarea]:box-border [&>textarea]:rounded-2xl",
                    rows: 1,
                    preventResize: true,
                    value: eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventLocation,
                    onChange: (data)=>{
                        setEventDetailsData((state)=>({
                                ...state,
                                eventLocation: data
                            }));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacesAutocompleteInput, {
                    className: "flex-1 mr-2",
                    value: initialMapLocationText,
                    mapUrl: (ref16 = eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventLocationMapUrl) !== null && ref16 !== void 0 ? ref16 : undefined,
                    onChangeText: ()=>{
                        setEventDetailsData((state)=>({
                                ...state,
                                eventLocationMapLink: undefined,
                                eventLocationMapUrl: undefined
                            }));
                    },
                    onSelect: (place)=>{
                        setEventDetailsData((state)=>({
                                ...state,
                                eventLocationMapLink: place.formattedAddress,
                                eventLocationMapUrl: place.mapUrl
                            }));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioFieldInput/* RadioFieldInput */.g, {
                    testid: "visibility-input",
                    hint: "(Private ".concat((eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? "fundraisers" : "events", " are only visible to your organisation)"),
                    options: [
                        "Private",
                        "Public"
                    ],
                    label: "".concat((eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser ? "Fundraiser" : "Event", " Visibility"),
                    className: "my-8 text-lg ml-[1px]",
                    value: (eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.publiclyListed) === false ? "Private" : "Public",
                    onChange: (data)=>{
                        setEventDetailsData((state)=>({
                                ...state,
                                publiclyListed: data === "Public"
                            }));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "mt-8 flex justify-between flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "text-lg",
                                    textColour: "textColour",
                                    children: "Select Date and Time"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                                            value: (ref17 = selectedTimeZoneOption === null || selectedTimeZoneOption === void 0 ? void 0 : selectedTimeZoneOption.label) !== null && ref17 !== void 0 ? ref17 : "",
                                            label: "Timezone",
                                            placeholder: "Search IANA timezones",
                                            options: timeZoneOptions,
                                            onChange: (data)=>{
                                                if (!(0,EventTime/* isValidTimeZoneId */.Ym)(data)) return;
                                                try {
                                                    const updated = setEventTimeZoneId(eventDetailsData, data);
                                                    setTimeZoneError(undefined);
                                                    setEventDetailsData(updated);
                                                } catch (error) {
                                                    setTimeZoneError(error instanceof Error ? error.message : "Unable to apply that timezone.");
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-1 text-sm opacity-75",
                                            children: "Your timezone is used only as the initial default. Search and select any timezone for the event."
                                        }),
                                        timeZoneError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-2 text-sm text-red-500",
                                            role: "alert",
                                            children: timeZoneError
                                        }),
                                        hasUnresolvedLegacyTimeZone && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "mt-2 text-sm text-amber-500",
                                            role: "alert",
                                            children: [
                                                "This event uses the legacy fixed offset",
                                                " ",
                                                eventDetailsData.timeZone,
                                                ". Select an IANA timezone before publishing; no location has been guessed."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "flex flex-col sm:flex-row justify-between sm:space-x-6 mt-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeInput/* DateTimeInput */.Y, {
                                    tooltip: "Start date/time is required to publish",
                                    labelBgColour: theme.backgroundColourSecondary,
                                    label: "Event Start",
                                    id: "start-time-input",
                                    testid: "start-time-input",
                                    required: (0,validation/* isFieldRequired */.zx)(validationRules.find((f)=>f[0].includes("event_startDateTime"))),
                                    value: eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.startDateTime,
                                    onChange: (data)=>{
                                        setEventDetailsData((state)=>({
                                                ...state,
                                                startDateTime: data
                                            }));
                                    },
                                    className: "flex-1",
                                    filterDate: (rawDate)=>{
                                        const date = moment_default()(rawDate);
                                        const today = moment_default()((0,EventTime/* instantToPickerDate */.qg)(new Date().toISOString(), eventTimeZone));
                                        if (date.isBefore(today, "day")) return false;
                                        return true;
                                    },
                                    filterTime: ()=>{
                                        return true;
                                    },
                                    clickIdOnChange: "end-time-input",
                                    timeZoneId: eventTimeZone
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeInput/* DateTimeInput */.Y, {
                                    timeZoneId: eventTimeZone,
                                    tooltip: "End date/time is required to publish",
                                    labelBgColour: theme.backgroundColourSecondary,
                                    id: "end-time-input",
                                    testid: "end-time-input",
                                    value: eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.endDateTime,
                                    validations: {
                                        greaterThanDate: (ref18 = eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.startDateTime) !== null && ref18 !== void 0 ? ref18 : ""
                                    },
                                    required: (0,validation/* isFieldRequired */.zx)(validationRules.find((f)=>f[0].includes("event_endDateTime"))),
                                    className: "flex-1",
                                    label: "Event End",
                                    filterDate: (rawDate)=>{
                                        const date = moment_default()(rawDate);
                                        const startTime = (0,EventTime/* instantToPickerDate */.qg)(eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.startDateTime, eventTimeZone);
                                        if (!!startTime && date.isBefore(startTime, "day")) return false;
                                        return true;
                                    },
                                    filterTime: (rawTime)=>{
                                        const time = moment_default()(rawTime);
                                        const startTime = moment_default()((0,EventTime/* instantToPickerDate */.qg)(eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.startDateTime, eventTimeZone));
                                        if (!!startTime && time.isSameOrBefore(startTime, "minute")) return false;
                                        return true;
                                    },
                                    onChange: (data)=>{
                                        setEventDetailsData((state)=>({
                                                ...state,
                                                endDateTime: data
                                            }));
                                    },
                                    initialDate: (ref20 = (0,EventTime/* instantToPickerDate */.qg)((ref19 = eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.registrationCloseDateTime) !== null && ref19 !== void 0 ? ref19 : eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.startDateTime, eventTimeZone)) !== null && ref20 !== void 0 ? ref20 : undefined
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeInput/* DateTimeInput */.Y, {
                                    tooltip: "The time attendees can access the event",
                                    labelBgColour: theme.backgroundColourSecondary,
                                    label: "Entry Time",
                                    id: "entry-time-input",
                                    testid: "entry-time-input",
                                    value: eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.entryDateTime,
                                    onChange: (data)=>{
                                        setEventDetailsData((state)=>({
                                                ...state,
                                                entryDateTime: data
                                            }));
                                    },
                                    className: "flex-1",
                                    filterDate: (rawDate)=>{
                                        const date = moment_default()(rawDate);
                                        const startTime = moment_default()((0,EventTime/* instantToPickerDate */.qg)(eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.startDateTime, eventTimeZone));
                                        if (date.isSameOrBefore(startTime, "day")) return true;
                                        return false;
                                    },
                                    filterTime: (rawTime)=>{
                                        const date = moment_default()(rawTime);
                                        const startTime = moment_default()((0,EventTime/* instantToPickerDate */.qg)(eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.startDateTime, eventTimeZone));
                                        if (date.isSameOrBefore(startTime, "minute")) return true;
                                        return false;
                                    },
                                    clickIdOnChange: "registration-close-time-input",
                                    timeZoneId: eventTimeZone
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeInput/* DateTimeInput */.Y, {
                                    timeZoneId: eventTimeZone,
                                    tooltip: "Registration close date/time is required to publish",
                                    labelBgColour: theme.backgroundColourSecondary,
                                    id: "registration-close-time-input",
                                    testid: "egistration-close-time-input",
                                    show: (eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.eventType) !== graphql/* EventType.Fundraiser */.tw.Fundraiser,
                                    value: eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.registrationCloseDateTime,
                                    required: (0,validation/* isFieldRequired */.zx)(validationRules.find((f)=>f[0].includes("event_registrationCloseDateTime"))),
                                    onChange: (data)=>{
                                        setEventDetailsData((state)=>({
                                                ...state,
                                                registrationCloseDateTime: data
                                            }));
                                    },
                                    className: "flex-1",
                                    label: "Registration Close",
                                    filterDate: (rawDate)=>{
                                        const date = moment_default()(rawDate);
                                        const endTime = moment_default()((0,EventTime/* instantToPickerDate */.qg)(eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.endDateTime, eventTimeZone));
                                        if (!!endTime && date.isAfter(endTime, "day")) return false;
                                        return true;
                                    },
                                    filterTime: (rawTime)=>{
                                        const time = moment_default()(rawTime);
                                        const endTime = moment_default()((0,EventTime/* instantToPickerDate */.qg)(eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.endDateTime, eventTimeZone));
                                        if (!!endTime && time.isAfter(endTime, "minute")) return false;
                                        return true;
                                    },
                                    clickIdOnChange: "end-time-input",
                                    initialDate: (ref21 = (0,EventTime/* instantToPickerDate */.qg)(eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.startDateTime, eventTimeZone)) !== null && ref21 !== void 0 ? ref21 : undefined
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "text-lg mt-6",
                    textColour: "textColour",
                    children: [
                        "Event",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-xs ml-2",
                            children: "(Optional: Image should be square and at least 800x800px)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "flex flex-wrap mt-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput/* FileInput */.S, {
                        uploadFile: uploadFile,
                        label: "Event Image",
                        hint: "",
                        crop: true,
                        cropAspectRatio: 1,
                        cropShape: "rect",
                        testid: "banner-upload",
                        value: eventDetailsData === null || eventDetailsData === void 0 ? void 0 : eventDetailsData.bannerImage,
                        onChange: (data)=>{
                            setEventDetailsData((state)=>({
                                    ...state,
                                    bannerImage: data
                                }));
                        }
                    })
                })
            ]
        })
    });
};
DetailsForm.Layout = CreateEventLayout/* default */.Z;
/* harmony default export */ var details = (DetailsForm);


/***/ })

}]);